module.exports = __webpack_public_path__ + "static/media/access-plus-small.b4897fa7.png";